import type { Components, Theme } from '@mui/material/styles';
import { varAlpha } from 'minimal-shared/utils';

// ----------------------------------------------------------------------

// v9 removed the `paperAnchor{Left,Right}` style keys; styles for the
// paper element must now go under the `paper` slot and branch on
// `ownerState.anchor`.
const MuiDrawer: Components<Theme>['MuiDrawer'] = {
  styleOverrides: {
    paper: ({ ownerState, theme }) => ({
      ...(ownerState.variant === 'temporary' &&
        ownerState.anchor === 'right' && {
          ...theme.mixins.paperStyles(theme),
          boxShadow: `-40px 40px 80px -8px ${varAlpha(theme.vars.palette.grey['500Channel'], 0.24)}`,
          ...theme.applyStyles('dark', {
            boxShadow: `-40px 40px 80px -8px ${varAlpha(theme.vars.palette.common.black, 0.24)}`,
          }),
        }),
      ...(ownerState.variant === 'temporary' &&
        ownerState.anchor === 'left' && {
          ...theme.mixins.paperStyles(theme),
          boxShadow: `40px 40px 80px -8px ${varAlpha(theme.vars.palette.grey['500Channel'], 0.24)}`,
          ...theme.applyStyles('dark', {
            boxShadow: `40px 40px 80px -8px ${varAlpha(theme.vars.palette.common.black, 0.24)}`,
          }),
        }),
    }),
  },
};

// ----------------------------------------------------------------------

export const drawer = { MuiDrawer };
